<template>
    <rkm-modal
        persistent
        ref="RkmModal"
        title="Opções de impressão"
    >
        <rkm-form
            ref="RkmForm"
            v-if="model"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-if="form.impressoes && form.impressoes.length > 1"
                        :indeterminate="indeterminate"
                        :value="true"
                        @change="checkUncheckAll"
                        v-model="checkedAll"
                    >
                        Todos
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group v-model="model.impressoes" stacked>
                        <rkm-form-checkbox
                            v-for="permissao in form.impressoes"
                            :key="permissao.value"
                            :value="permissao.value"
                            :disabled="permissao.disabled"
                            class="mb-0"

                        >
                            {{ permissao.text }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="close">
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="(model && model.impressoes ? model.impressoes.length === 0 : true) || !!loading"
                @click="print"
                color="primary"
            >
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

// Utils.
import cartaoNacionalSaude from '@/utils/cadastro/impressao/cartaoNacionalSaude'
import etiqueta from '@/utils/cadastro/impressao/etiqueta'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'

// Moment.
import moment from 'moment'

export default {
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            cliente: 'getCliente',
            loading: 'getLoading',
            lotacao: 'getLotacao',
        }),
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
            impressaoCadastro: this.getConectaSusRepository('impressao.cadastro'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data: () => ({
        checkedAll: false,
        enums: {sexo},
        form: null,
        indeterminate: false,
        model: null,
        utils: { cartaoNacionalSaude, etiqueta },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(id) {
            this.load(id)

            this.$refs.RkmModal.show()
        },
        load(id) {
            this.setLoading()

            this.repositories.paciente.getPrintFormModelData(id)
                .then(({ data }) => {
                    this.form = Object.assign(data.form)
                    this.model = Object.assign(data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        checkUncheckAll(value) {
            this.model.impressoes = value
                ? this.form.impressoes.filter(item => !item.disabled).map(impressao => impressao.value)
                : []
        },
        print() {

            const repositoryItems = {
                termoRecusaCadastro: () =>this.repositories.impressao.termoRecusaCadastro(this.model.id),
                cadastroIndividual: () =>this.repositories.impressao.ficha(this.model.id),
                cadastroDomiciliar: () =>this.repositories.impressao.fichaCadastroDomiciliar(this.model.cadastroDomiciliarId),
                residentes: () =>this.repositories.impressao.fichaResidentes(this.model.domicilioId),
                folhaRosto: () => this.repositories.impressaoCadastro.pacienteFolhaRosto(this.model.id),
            }

            this.model.impressoes.forEach(impressao => {

                if (impressao in repositoryItems) {

                    this.setLoading()

                    repositoryItems[impressao]()
                        .then(({data, headers}) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }

                if (impressao == 'etiquetaConectasus') {

                    this.utils.etiqueta.print({
                        form: this.form,
                        model: this.model,
                        unidadeLogada: this.lotacao.infraestrutura.nome,
                        sexo: this.model.cidadao.sexoId === this.enums.sexo.FEMININO ? 'F' : 'M',
                        dataNascimento: moment(this.model.cidadao.dataNascimento).format('DD/MM/YYYY'),
                    })
                }

                if (impressao == 'cartaoNacionalSaude') {
                    this.utils.cartaoNacionalSaude.print(this.model.cidadao)
                }
            })
        },
        close() {
            this.$refs.RkmModal.hide()
            this.$emit('closed')
        },
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        'model.impressoes'(value) {
            this.checkedAll = value.length > 0 && value.length == this.form.impressoes.length
            this.indeterminate = value.length > 0 && value.length != this.form.impressoes.length
        },
    },
}
</script>